"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _luxon = require("luxon");

var _chartUtils = require("../../chartUtils");

var _Styles = require("./Styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CustomerHint = function CustomerHint(_ref) {
  var selectedCoordinate = _ref.selectedCoordinate,
      dateFormat = _ref.dateFormat,
      zone = _ref.zone;
  return /*#__PURE__*/_react["default"].createElement(_Styles.HintBox, null, /*#__PURE__*/_react["default"].createElement(_Styles.HintBody, null, _luxon.DateTime.fromISO(selectedCoordinate.x, {
    zone: zone
  }).toFormat(dateFormat), selectedCoordinate.coordinates.map(function (coordinate) {
    if ((0, _chartUtils.isNumeric)(coordinate.y) && coordinate.y > 0) {
      return /*#__PURE__*/_react["default"].createElement(_Styles.HintItem, null, coordinate.color && /*#__PURE__*/_react["default"].createElement(_Styles.HintDot, {
        style: {
          background: coordinate.color
        }
      }), coordinate.icon && /*#__PURE__*/_react["default"].createElement(coordinate.icon, null), coordinate.name ? coordinate.name : '', /*#__PURE__*/_react["default"].createElement("b", null, " ".concat(parseFloat(coordinate.y).toFixed(2))), " kWh");
    }
  })));
};

CustomerHint.propTypes = {
  selectedCoordinate: _propTypes["default"].shape({
    x: _propTypes["default"].string,
    y: _propTypes["default"].number,
    coordinate: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  }).isRequired,
  dateFormat: _propTypes["default"].string.isRequired,
  zone: _propTypes["default"].string.isRequired
};
var _default = CustomerHint;
exports["default"] = _default;